import type { Match } from 'found';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { fetchCollections } from '../actions/collections.actions';
import type { AsyncActionStatus } from '../actions/common.actionTypes';
import FollowedCollections from '../components/FollowedCollections';
import withAsyncData from '../components/utils/withAsyncData';
import type { StoreType } from '../reducers';
import { selectFollowedCollections } from '../reducers/collections.selectors';
import type { CollectionProperties } from '../types/AppContent';

interface StateProps {
	collections: CollectionProperties[];
	collectionsStatus: AsyncActionStatus;
}

type FollowedCollectionListPageProps = StateProps & Match;

const FollowedCollectionListPage: React.FC<FollowedCollectionListPageProps> = ({
	collections,
	collectionsStatus,
}) => {
	return <FollowedCollections collections={collections} collectionsStatus={collectionsStatus} />;
};

const mapState = (state: StoreType): StateProps => ({
	collections: selectFollowedCollections(state),
	collectionsStatus: state.collections.followed.status,
});

export default compose<React.FC<Record<string, never>>>(
	connect(mapState, { fetchCollections }),
	withAsyncData((props) => ({
		refetch: () => props.fetchCollections(),
		dataProp: 'collections',
		statusProp: 'collectionsStatus',
	}))
)(FollowedCollectionListPage);
